import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePickerInput } from './datepicker-input.component';
import { IconModule } from '../icon/icon.module';

@NgModule({
  declarations: [
    DatePickerInput
  ],
  exports: [
    DatePickerInput
  ],
  imports: [
    CommonModule,
    IconModule,
  ]
})
export class DatePickerInputModule { }
